export function getUserCookieExpirationDate(): Date {
	const cookieExpiryMilliseconds = 2629746000
	const date = new Date()
	date.setTime(date.getTime() + cookieExpiryMilliseconds)
	return date
}
